<template>
    <v-card color="background" height="100%" style="border-radius: 0px">
        <v-row align="center" justify="center" style="margin-top: -50px; margin-bottom: 10px;">
            <v-col align="center">
                <img src="@/assets/logo-paoli.png" width="180px" />
            </v-col>
            <v-col align="center">
                <img src="@/assets/logo-b&j.png" width="250px" />
            </v-col>
        </v-row>
        <v-app-bar app dark color="primary" clipped-left style="position: relative;">
            <v-app-bar-nav-icon @click="drawer = true" class="d-flex d-sm-none"></v-app-bar-nav-icon>

            <v-spacer></v-spacer>

            <div class="d-none d-sm-flex">
                <div v-for="(item, index) in sidebarMenu" :key="index">
                    <v-btn text :to="item.route">
                        {{ item.name }}
                    </v-btn>
                </div>
                <v-menu v-if="user" min-width="200" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <!-- <div class="logged-user d-none d-sm-flex ml-4">
                            <span class="logged-user-name font-weight-bold">{{ user.name }}</span>
                            <span class="logged-user-email">{{ user.email }}</span>
                        </div> -->

                        <v-btn text v-bind="attrs" v-on="on">
                            <v-icon class="mr-2">mdi-account</v-icon>
                            {{ user ? 'Olá, ' + normalizeName(user.name) : ' Cadastre-se / Login' }}
                        </v-btn>

                    </template>
                    <v-list>
                        <v-list-item link :to="null" color="primary" @click.native="logout">
                            <v-list-item-icon>
                                <v-icon>mdi-logout</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title>Sair</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-btn v-else text @click="dialogAccess = true">
                    <v-icon class="mr-2">mdi-account</v-icon>
                    Cadastre-se / Login
                </v-btn>
            </div>

            <v-spacer></v-spacer>


        </v-app-bar>

        <v-navigation-drawer v-model="drawer" absolute temporary color="primary">
            <v-list nav dense>
                <v-list-item-group>
                    <v-list-item v-if="user" class="mt-10">
                        <v-list-item-content>
                            <v-list-item-title><span class="white--text"><v-icon
                                        class="mr-2 white--text">mdi-account</v-icon>
                                    {{ 'Olá, ' + normalizeName(user.name)
                                    }}</span></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-for="(item, index) in sidebarMenu" :key="index" link :to="item.route" color="white">
                        <v-list-item-content>
                            <v-list-item-title><span class="white--text">{{ item.name }}</span></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="!user" class="mt-10" @click="dialogAccess = true">
                        <v-list-item-content>
                            <v-list-item-title><span class="white--text"> <v-icon
                                        class="mr-2 white--text">mdi-account</v-icon>
                                    Cadastre-se / Login</span></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-else class="mt-10" @click="logout">
                        <v-list-item-content>
                            <v-list-item-title><span class="white--text"> <v-icon
                                        class="mr-2 white--text">mdi-logout</v-icon>
                                    Sair</span></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>

        <v-dialog persistent v-model="dialogRegister" :width="600">
            <register-component></register-component>
        </v-dialog>

        <v-dialog v-model="dialogForgotPassword" :width="600">
            <forgot-password-component></forgot-password-component>
        </v-dialog>

        <v-dialog v-model="dialogAccess" :width="600">
            <access-component></access-component>
        </v-dialog>

        <progress-bar></progress-bar>

        <router-view></router-view>

    </v-card>
</template>

<script>
import { eventHub } from "@/main";

import router from '../router';

import ProgressBar from "@/components/layout/ProgressBar.vue"
import Register from "@/views/user/Register.vue"
import Access from "@/views/user/Access.vue"
import ForgotPassword from "@/views/user/ForgotPassword.vue"

import sidebarMenu from "@/common/data/sidebar-menu.data"

export default {
    name: "PublicLayout",

    components: {
        'progress-bar': ProgressBar,
        'register-component': Register,
        'access-component': Access,
        'forgot-password-component': ForgotPassword
    },

    data() {
        return {
            user: null,
            logoUrl: null,
            menuGroups: [],
            drawer: false,
            dialogRegister: false,
            dialogAccess: false,
            dialogForgotPassword: false,
            searchTerm: null,
            displaySettingsMenu: false,
            sidebarMenu: sidebarMenu,
        };
    },

    computed: {
        routeName() {
            return this.$route.name;
        },
    },

    created() {

        this.user = this.$root.user;

        eventHub.$on("DIALOG-REGISTER", (value) => {
            this.dialogRegister = value;
        });

        eventHub.$on("DIALOG-FORGOT-PASSWORD", (value) => {
            this.dialogForgotPassword = value;
        });

        eventHub.$on("DIALOG-ACCESS", (value) => {
            this.dialogAccess = value;
        });

        this.$ga.enable();

        eventHub.$on("logout", () => {
            this.logout();
        })

        this.setActionButtons();

    },

    destroyed() {
        eventHub.$off("THEME_UPDATED");
    },

    methods: {
        setActionButtons() {
            // Grupo
        },

        // closeMenu() {
        //     this.$refs.menu.save()
        // },

        menuActionClick(event) {
            event.preventDefault()
        },

        normalizeName(name) {
            const splitName = name.split(' ');
            return splitName.length > 1 ? splitName[0] : name
        },

        async logout() {
            // if (await this.$root.$confirm(true, "user.logout")) {
            //     userApi.clearcurrentUser;
            //     this.$router.push({ name: "Login" });
            // }

            localStorage.clear();
            router.go("/home");
        },
    },
};
</script>

<style scoped lang="scss" >
.title {
    color: var(--v-primary-base);
    text-decoration: none;
}

.menu-button-container {
    background-color: var(--v-secondary-base) !important;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 80px;
    text-align: center;
}

.menu-button {
    margin: auto;
    bottom: 0;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
}

.logged-user {
    text-align: left;
    margin-right: 10px;
    font-size: 13px;
    font-weight: 400;
    flex-direction: column;

    &-name {
        display: block;
    }

    &-email {
        display: block;
    }
}

.menu-subheader {
    padding-left: 16px;
    color: var(--v-primary-base);
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.001px;
}

.menu-title {
    padding-left: 16px;
    color: var(--v-important-base);
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
}
</style>